import React from "react";

/** Colours studios type most; a tap fills the Colour field (it stays free text for "peacock blue, gold border"). */
export const COMMON_COLOURS: Array<[string, string]> = [
  ["Red", "#b3202e"],
  ["Green", "#2f6b4f"],
  ["Kora", "#e9dcc0"],
  ["White", "#f7f5f0"],
  ["Rani", "#c2185b"],
  ["Pink", "#e7a1b5"],
  ["Blue", "#2d4f9e"],
  ["Black", "#1d1d1f"],
];

const ColourChips = ({ value, onPick }: { value?: string; onPick: (colour: string) => void }) => {
  const current = String(value || "").trim().toLowerCase();
  return (
    <div className="ps-colours" role="group" aria-label="Common colours">
      {COMMON_COLOURS.map(([name, hex]) => (
        <button
          key={name}
          type="button"
          className={`ps-chip-btn${current.startsWith(name.toLowerCase()) ? " is-on" : ""}`}
          onClick={() => onPick(name)}
        >
          <i style={{ background: hex }} />
          {name}
        </button>
      ))}
    </div>
  );
};

export default ColourChips;
